import React, {useState} from "react"
import {Btn, FormInput, FormSelect, FormTextarea, Modal} from "./";
import {useCore} from "../hooks";
import {CustomCheckoutOrder} from "../store/core/reducer.ts";
import {toast} from "react-toastify";
import {PaymentItem} from "depoto-core";
import {generateUuidV4} from "../utils";

type Props = {
  order: CustomCheckoutOrder
  onUpdate: () => void
}
export const ModalPaymentsOnExistingOrder: React.FC<Props> = ({ order, onUpdate }) => {
  const { core, payments } = useCore()
  const [isVisible, setIsVisible] = useState<boolean>(false)
  const [paymentItems, setPaymentItems] = useState<PaymentItem[]>([])

  const openModal = () => {
    setPaymentItems(order?.paymentItems?.map(pi => ({...pi, uuid: generateUuidV4()})) || [])
    setIsVisible(true)
  }

  const closeModal = () => {
    setPaymentItems([])
    setIsVisible(false)
  }

  const updatePaymentItem = (paymentItemUuid: string, paymentId?: number, amount?: number) => {
    const nextPaymentItems = [...paymentItems]
    for (const pi of nextPaymentItems) {
      if (pi.uuid === paymentItemUuid) {
        if (paymentId) {
          pi.payment = payments.find(p => p.id === paymentId)
        }
        if (amount) {
          pi.amount = amount
        }
      }
    }
    setPaymentItems(nextPaymentItems)
  }

  const removePaymentItem = async (paymentItemUuid: string) => {
    const pi = paymentItems.find(pi => pi.uuid === paymentItemUuid)
    const resDelete = await core.services.order.deletePaymentItem(pi)
    setPaymentItems(paymentItems.filter(pi => pi.uuid !== paymentItemUuid))
  }

  const addPaymentItem = () => {
    setPaymentItems([...paymentItems, new PaymentItem({
      uuid: generateUuidV4(),
      payment: payments[0],
      amount: 0,
    })])
  }

  const updateOrderPayments = async () => {
    const nextOrder = { id: order.id, paymentItems: paymentItems }
    // todo fragments. keep it simple for now, so fck zeus
    // @ts-ignore
    const res = await core.services.order.updateOrderPart(nextOrder)
    toast.success('Platby byly upraveny')
    onUpdate()
    closeModal()
  }

  return (
    <Modal
      modalOpenBtn={<Btn className="btn-base-100" children={'Upravit platby'} onClick={openModal} />}
      isVisible={isVisible}
      modalTitle={'Platby'}
      modalWidth={'sm'}
      onClose={closeModal}
      recalcHeightHash={paymentItems?.length}
      content={
        <div>
          {paymentItems?.length > 0 ? paymentItems.map(pi => (
            <div key={`payment-item-${pi.uuid}`} className="flex flex-row">
              <FormSelect options={payments.map(p => ({ value: p.id, label: p.name }))} value={pi.payment.id} onChange={paymentId => updatePaymentItem(pi.uuid, Number(paymentId))} />
              <FormInput type="number" value={`${pi.amount}`} onChange={val => updatePaymentItem(pi.uuid, undefined, Number(val))} />
              <Btn className="btn-base-100" icon={'fa-times'} onClick={() => removePaymentItem(pi.uuid)}/>
            </div>
          )) : null}
          <Btn className="btn-base-100" icon={'fa-plus'} children={'Přidat platbu'} onClick={() => addPaymentItem()}/>
        </div>
      }
      footerContent={
        <div className="flex flex-row justify-between items-center">
          <Btn className="btn-base-100" icon={'fa-times'} children={'Zrušit'} onClick={() => setIsVisible(false)}/>
          <Btn className="btn-primary" icon={'fa-check'} children={'Upravit platby'} onClick={updateOrderPayments}/>
        </div>
      }
    />
  )
}
